import React from 'react'
import './index.less'

import http from 'src/helper/http'
import { setDocumentTitle } from 'src/helper/tool'
import { history } from 'src/core/router'
// import { observable, action, autorun, computed, toJS } from 'mobx'
import brower from 'src/helper/brower'
import moment from "moment"
import lang from './lang'

export default class extends React.Component {
  state = {
  }

  constructor(props) {
    super(props)
  }

  render() {
    // let {
    //   historyInfo,
    //   uid,
    // } = this.props.store
    let { isOpenHis, lang, historyInfo, uid } = this.props
    let { hisList } = this.state
    if (isOpenHis && historyInfo.length > 0) {
      // document.getElementById('his_list_id').scrollTop = 0;
    }
    return (
      <div
        style={{ transform: `translateY(${isOpenHis ? "0" : "100vh"})` }}
        className={`his_page ${isOpenHis ? "openPopupRank" : "none"}`} onClick={(e) => this.props.onCloseHis()}>
        <div className={`his_box`} onClick={(e) => e.stopPropagation()}>
          <div className='title'>{lang.Record}<img src="/img/activity/fruitgame/icon-close.png" onClick={() => this.props.onCloseHis()} /></div>
          {
            historyInfo.length > 0 &&
            <div className='his_list' id="his_list_id">
              <div className="scroll-box">
                {
                  (historyInfo || []).map((r, i) => {
                    return (
                      <div className='every_his' key={i}>
                        <div className='his_info'>
                          <div className='info_1'>{lang.Round} {r.roundId}</div>
                          <div className='info_1'>{moment((r.ts * 1000)).format('YYYY/MM/DD hh:mm:ss')}</div>
                        </div>
                        <div className='his_info'>

                          <div className='info_1'>{lang.WinningFruit} {r.fruitId > -1 && <img src={`/img/activity/fruit/afruit${r.fruitId + 1}.png`} />}</div>
                        </div>
                        <div className='his_table'>
                          <div className='his_td'>
                            <div className='select'>{lang.YourSeleted}</div>
                            <div className='bet'>{lang.Bet}</div>
                            <div className='win'>{lang.Win}</div>
                          </div>
                          {
                            r.betList.map((l, index) => {
                              return (
                                <div className='his_td' key={index}>
                                  <div className='select'><img src={`/img/activity/fruit/afruit${l.fruitId + 1}.png`} /></div>
                                  <div className='bet'><img src="/img/gold.png" />{l.coins}</div>
                                  {r.fruitId == -1 ? <div className='win'>Waiting</div> : ''}
                                  {r.fruitId > -1 ? <div className='win'><img src="/img/gold.png" />{r.fruitId == l.fruitId ? r.rewardCoins : 0}</div> : ''}
                                </div>
                              )
                            })
                          }
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          }
          {
            historyInfo.length == 0 &&
            <div className='no_data'>
              <div className='no_pic'><img src="/img/content_null_1.png" /></div>
              <div className='no_word'>{lang.noRecord}</div>
            </div>
          }

        </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// src/pages/activity/fruit1103/history.js